import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IKindVersion } from '../model/kind/KindVersion';
import type { IKindVersionSearchParams } from '../api/requests/kinds/kindVersionApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';


interface useFindKindsResult {
    isLoaded: boolean;
    kinds: IKindVersion[];
}


export const useFindKinds = (searchParams: IKindVersionSearchParams) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useFindKindsResult>(() => ({ isLoaded: false, kinds: [] }));

    useEffect(() => {
        setResult({ isLoaded: false, kinds: [] });
        rootStore.kindVersionStore.findAllCurrentKindVersions(searchParams)
            .then((kinds) => {
                setResult({ isLoaded: true, kinds: kinds });
            })
            .catch(e => publishNotification({
                text: `Error finding kinds: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.kindVersionStore, publishNotification, searchParams]);

    return result;
};
